"use strict";
/**
 * Basketball Mode UI
 * Slippage curves and hint/factor display updates for the basketball order
 * button layout (MISC / EXT split top row, 2PTR, 3PTR, SELL per side).
 * Layout visibility is handled by sport-mode.ts.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASKETBALL_SLIPPAGE_CURVES = void 0;
exports.getBasketballSlippage = getBasketballSlippage;
exports.updateBasketballSlippageHints = updateBasketballSlippageHints;
exports.updateBasketballFactorDisplay = updateBasketballFactorDisplay;
const state_1 = require("../state");
const sport_mode_1 = require("./sport-mode");
/**
 * Factor curves per shot type. Both start at 0 (exact low ask at factor 0);
 * 3PTR ramps faster than 2PTR. Coefficients are tuned so factor 1 rounds to
 * 0% for 2PTR and 1% for 3PTR (a gentler ramp than the baseball curves they
 * were forked from).
 */
exports.BASKETBALL_SLIPPAGE_CURVES = {
    two_ptr: { base: 0, linear: 0.35, quadratic: 0.03 },
    three_ptr: { base: 0, linear: 0.8, quadratic: 0.06 },
};
/**
 * Calculate effective slippage for a shot type and factor.
 * At factor 0 both shot types return 0 (fire at the exact low ask).
 */
function getBasketballSlippage(shot, factor) {
    return (0, sport_mode_1.evaluateSlippageCurve)(exports.BASKETBALL_SLIPPAGE_CURVES[shot], factor);
}
// ---------------------------------------------------------------------------
// Hint + factor display
// ---------------------------------------------------------------------------
/**
 * Update all slippage hint labels on basketball buttons for the given factor.
 *
 * In combined mode (basketball + manual price), the MISC/2PTR/3PTR hint
 * elements show manual prices managed by the sport pricing engine's hint
 * refresh; this function only updates them when NOT in combined mode,
 * avoiding a flash of stale slippage values. MISC shows 0% at every factor;
 * EXT has no slippage.
 */
function updateBasketballSlippageHints(factor) {
    const combined = (0, sport_mode_1.isCombinedPricingMode)((0, state_1.getState)().tradingSettings);
    const sides = ["a", "b"];
    if (!combined) {
        for (const side of sides) {
            const misc = document.getElementById(`bk-misc-${side}-slip`);
            if (misc)
                misc.textContent = "0%";
            const twoPtr = document.getElementById(`bk-2ptr-${side}-hint`);
            if (twoPtr)
                twoPtr.textContent = `${getBasketballSlippage("two_ptr", factor)}%`;
            const threePtr = document.getElementById(`bk-3ptr-${side}-hint`);
            if (threePtr)
                threePtr.textContent = `${getBasketballSlippage("three_ptr", factor)}%`;
        }
    }
}
/**
 * Update the basketball factor display and slider, then refresh the slippage
 * hints. The slider range (0–20) is narrower than the ± buttons' clamp (40);
 * assigning past the max pegs the slider there.
 */
function updateBasketballFactorDisplay(factor) {
    const display = document.getElementById("bk-factor-display");
    if (display)
        display.textContent = factor.toString();
    const slider = document.getElementById("bk-factor-slider");
    if (slider)
        slider.value = factor.toString();
    updateBasketballSlippageHints(factor);
}
